<script setup lang="ts">
const contactsStore = useMyContactsStore()
const { contacts } = storeToRefs(contactsStore)

const backgrounds: Record<string, string> = {
  email: 'linear-gradient(180deg,#b797f6,#9873ea)',
  phone: 'linear-gradient(180deg,#f8a8c2,#f18bb0)',
  linkedin: 'linear-gradient(180deg,#6fa6e8,#4a83d4)',
  github: 'linear-gradient(180deg,#8c93a8,#5f6779)',
  instagram: 'linear-gradient(180deg,#f6a8c4,#e979a6)',
  twitter: 'linear-gradient(180deg,#8c93a8,#5f6779)',
  facebook: 'linear-gradient(180deg,#6fa6e8,#4a83d4)',
  whatsapp: 'linear-gradient(180deg,#8ede9a,#5cc86e)',
  telegram: 'linear-gradient(180deg,#7fc4f2,#54a9e8)'
}
</script>

<template>
  <section id="contact" data-reveal class="rounded-[26px] p-5 shadow-[var(--t-clay)] [background:var(--t-sect4)]">
    <div class="flex items-center justify-between gap-2.5">
      <h2 class="text-base font-extrabold text-[var(--t-h14)]">تماس با من</h2>
      <span class="rounded-full bg-white/80 px-3 py-1 text-[11px] font-bold text-[var(--t-badge4)]
                   shadow-[inset_0_2px_3px_rgb(255_255_255/0.9),0_3px_8px_rgb(190_70_120/0.12)]">پاسخ در کمتر از یک روز</span>
    </div>
    <ul class="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      <li v-for="contact in contacts" :key="contact.id">
        <a :href="contact.href"
           :target="contact.external ? '_blank' : undefined"
           :rel="contact.external ? 'noopener noreferrer' : undefined"
           class="flex items-center gap-2.5 rounded-[20px] bg-white/82 p-3 text-[var(--t-h14)]
                  shadow-[inset_0_2px_3px_rgb(255_255_255/0.96),0_6px_12px_rgb(190_70_120/0.10)]
                  transition duration-300 hover:-translate-y-1 hover:shadow-[var(--t-clay)]">
          <span class="grid h-[38px] w-[38px] shrink-0 place-content-center rounded-[13px] text-white
                       shadow-[inset_0_3px_4px_rgb(255_255_255/0.55),inset_0_-4px_6px_rgb(70_40_140/0.25),0_6px_12px_rgb(90_60_160/0.22)]"
                :style="{ background: backgrounds[contact.icon] }">
            <SharedContactIcon :kind="contact.icon" class="h-[18px] w-[18px] drop-shadow-[0_1.5px_1px_rgb(70_40_140/0.3)]" />
          </span>
          <span class="grid min-w-0 gap-0.5">
            <span class="truncate text-[12.5px] font-extrabold">{{ contact.key }}</span>
            <span v-if="contact.displayValue" class="truncate text-right text-[11px] text-[var(--t-soft4)] [direction:ltr]">
              {{ contact.displayValue }}
            </span>
          </span>
        </a>
      </li>
    </ul>
  </section>
</template>
